(function () {
/* eslint-disable prettier/prettier */ function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}



function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}



"use strict";
var $3d28d7f1aac198f5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Game() {
        var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.initialState = initialState;
        this.gameScore = 0;
        this.state = (0, $227c6742e0ff6f82$export$71511d61b312f219)(this.initialState);
        this.size = 4; // The size of the board (4x4)
        this.lastGameScore = 2048; // The score to win the game
        this.status = "idle";
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "start",
            value: function start() {
                this.status = "playing";
                this.addCell();
                this.addCell();
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.status = "idle";
                this.state = [
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ]
                ];
                this.gameScore = 0;
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.gameScore;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.state;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                var canMove = false;
                var newState = [];
                for(var i = 3; i >= 0; i--){
                    var row = this.state[i].filter(function(number) {
                        return number !== 0;
                    });
                    for(var n = 1; n < row.length; n++)if (row[n] === row[n - 1]) {
                        row[n - 1] *= 2;
                        delete row[n];
                        this.gameScore += row[n - 1];
                    }
                    var newRow = row.filter(function(number) {
                        return number !== undefined;
                    });
                    for(var j = newRow.length; j < this.size; j++)newRow.push(0);
                    newState[i] = newRow;
                }
                for(var i1 = 0; i1 <= this.size - 1; i1++){
                    for(var n1 = 0; n1 <= this.size - 1; n1++)if (newState[i1][n1] !== this.state[i1][n1]) canMove = true;
                }
                if (canMove) {
                    this.state = newState;
                    this.addCell();
                }
                this.isLose();
                this.isWin();
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var newState = [];
                var canMove = false;
                for(var i = 3; i >= 0; i--){
                    var row = this.state[i].filter(function(number) {
                        return number !== 0;
                    });
                    for(var n = row.length - 1; n >= 0; n--)if (row[n] === row[n - 1]) {
                        row[n] *= 2;
                        row[n - 1] = 0;
                        this.gameScore += row[n];
                    }
                    var newRow = row.filter(function(number) {
                        return number !== 0;
                    });
                    for(var j = newRow.length; j < this.size; j++)newRow.unshift(0);
                    newState[i] = newRow;
                }
                for(var i1 = 0; i1 <= 3; i1++){
                    for(var n1 = 0; n1 <= 3; n1++)if (newState[i1][n1] !== this.state[i1][n1]) canMove = true;
                }
                if (canMove) {
                    this.state = newState;
                    this.addCell();
                }
                this.isLose();
                this.isWin();
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                this.state = this.updateState(this.state);
                this.moveLeft();
                this.state = this.updateState(this.state);
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                this.state = this.updateState(this.state);
                this.moveRight();
                this.state = this.updateState(this.state);
            }
        },
        {
            key: "addCell",
            value: function addCell() {
                var initial = Math.random() > 0.1 ? 2 : 4;
                var count = 0;
                do {
                    var row = Math.round(Math.random() * 3);
                    var column = Math.round(Math.random() * 3);
                    if (this.state[row][column] === 0) {
                        this.state[row][column] = initial;
                        count++;
                    }
                }while (count < 1);
            }
        },
        {
            key: "updateState",
            value: function updateState(state) {
                var newState = [];
                for(var i = 0; i <= this.size - 1; i++)newState.push([
                    state[0][i],
                    state[1][i],
                    state[2][i],
                    state[3][i]
                ]);
                return newState;
            }
        },
        {
            key: "isWin",
            value: function isWin() {
                for(var i = 0; i <= this.size - 1; i++){
                    for(var n = 0; n <= this.size - 1; n++)if (this.state[i][n] === this.lastGameScore) this.status = "win";
                }
            }
        },
        {
            key: "isLose",
            value: function isLose() {
                for(var i = 0; i < this.size; i++)for(var j = 0; j < this.size; j++){
                    if (this.state[i][j] === 0) return;
                    if (i < 3 && this.state[i][j] === this.state[i + 1][j] || j < 3 && this.state[i][j] === this.state[i][j + 1]) return;
                }
                this.status = "lose";
            }
        }
    ]);
    return Game;
}();


'use strict';
var $197cd56b15c33885$var$BOARD_SIZE = 4; // Size of the game board
var $197cd56b15c33885$var$game = new (0, $3d28d7f1aac198f5$export$2e2bcd8739ae039)();
var $197cd56b15c33885$var$controls = document.querySelector('.controls');
var $197cd56b15c33885$var$gameScore = document.querySelector('.game-score');
var $197cd56b15c33885$var$tbody = document.querySelector('tbody');
var $197cd56b15c33885$var$messageStart = document.querySelector('.message-start');
var $197cd56b15c33885$var$messageLose = document.querySelector('.message-lose');
var $197cd56b15c33885$var$messageWin = document.querySelector('.message-win');
var $197cd56b15c33885$var$buttonRestart = document.createElement('button');
var $197cd56b15c33885$var$buttonStart = document.querySelector('.start');
$197cd56b15c33885$var$buttonRestart.classList.add('restart');
$197cd56b15c33885$var$buttonRestart.classList.add('button');
$197cd56b15c33885$var$buttonRestart.textContent = 'Restart';
$197cd56b15c33885$var$buttonStart.addEventListener('click', function() {
    $197cd56b15c33885$var$game.start();
    $197cd56b15c33885$var$messageStart.classList.add('hidden');
    $197cd56b15c33885$var$board();
    $197cd56b15c33885$var$buttonStart.remove();
    $197cd56b15c33885$var$controls.append($197cd56b15c33885$var$buttonRestart);
});
$197cd56b15c33885$var$buttonRestart.addEventListener('click', function() {
    $197cd56b15c33885$var$game.restart();
    $197cd56b15c33885$var$game.start();
    $197cd56b15c33885$var$board();
    $197cd56b15c33885$var$messageWin.classList.add('hidden');
    $197cd56b15c33885$var$messageLose.classList.add('hidden');
});
document.addEventListener('keydown', function(e) {
    if ($197cd56b15c33885$var$game.status !== 'playing') return;
    var oldState = JSON.parse(JSON.stringify($197cd56b15c33885$var$game.getState()));
    switch(e.key){
        case 'ArrowLeft':
            $197cd56b15c33885$var$game.moveLeft();
            break;
        case 'ArrowRight':
            $197cd56b15c33885$var$game.moveRight();
            break;
        case 'ArrowUp':
            $197cd56b15c33885$var$game.moveUp();
            break;
        case 'ArrowDown':
            $197cd56b15c33885$var$game.moveDown();
            break;
    }
    if ($197cd56b15c33885$var$game.status === 'win') $197cd56b15c33885$var$messageWin.classList.remove('hidden');
    if ($197cd56b15c33885$var$game.status === 'lose') $197cd56b15c33885$var$messageLose.classList.remove('hidden');
    if ($197cd56b15c33885$var$buttonStart) {
        $197cd56b15c33885$var$buttonStart.remove();
        $197cd56b15c33885$var$controls.append($197cd56b15c33885$var$buttonRestart);
    }
    $197cd56b15c33885$var$board(oldState);
});
var $197cd56b15c33885$var$board = function(oldState) {
    $197cd56b15c33885$var$gameScore.textContent = $197cd56b15c33885$var$game.getScore();
    var rows = (0, $227c6742e0ff6f82$export$71511d61b312f219)($197cd56b15c33885$var$tbody.querySelectorAll('.field-row'));
    for(var i = 0; i < $197cd56b15c33885$var$BOARD_SIZE; i++){
        var _loop = function(j) {
            var cells = (0, $227c6742e0ff6f82$export$71511d61b312f219)(rows[i].querySelectorAll('.field-cell'));
            var cellValue = $197cd56b15c33885$var$game.getState()[i][j];
            if (cellValue === 0) {
                cells[j].textContent = '';
                cells[j].className = 'field-cell';
            } else {
                cells[j].textContent = cellValue;
                cells[j].className = 'field-cell';
                cells[j].classList.add('field-cell--' + cellValue);
                if (oldState && cellValue === oldState[i][j] * 2) {
                    cells[j].classList.add('tile-merged');
                    setTimeout(function() {
                        return cells[j].classList.remove('tile-merged');
                    }, 200);
                }
            }
        };
        for(var j = 0; j < $197cd56b15c33885$var$BOARD_SIZE; j++)_loop(j);
    }
};

})();
//# sourceMappingURL=js-2048-game.44b3e559.js.map
